import { atom, selector } from 'recoil'

export const PAGE_STATE_INITIAL = 'initial'
export const PAGE_STATE_ERROR = 'error'
export const PAGE_STATE_READY = 'ready'

export const pageState = atom({
  key: 'EmailSendingQueueManage__PageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    status: PAGE_STATE_INITIAL,
    severity: 'danger',
    title: undefined
  }
})

export const pecPlusConfigState = atom({
  key: 'EmailSendingQueueManage__pecPlusState',
  default: {
    isListPecPlus: undefined,
    statusListPecPlus: undefined,
    listName: undefined
  }
})

export const abTestState = atom({
  key: 'EmailSendingQueueManage__abTestState',
  default: {
    idAbTest: 0,
    abTestDetails: undefined
  }
})

export const fasciaDiNonDisturboState = atom({
  key: 'EmailSendingQueueManage__dFasciaDiNonDisturboStateState',
  default: {
    enable: false,
    isFirstConfiguration: true,
    isDirty: false,
    Start: {
      hours: 0,
      minutes: 0
    },
    End: {
      hours: 7,
      minutes: 0
    }
  }
})

export const fasciaDiNonDisturboInvalidSelector = selector({
  key: 'EmailSendingQueueManage__SetFasciaDiNonDisturboValid',
  get: ({ get }) => {
    const { Start, End, enable } = get(fasciaDiNonDisturboState)
    if (Start.hours === End.hours && Start.minutes === End.minutes && enable) {
      return true
    } else {
      return false
    }
  }
})

export const smartPlanningState = atom({
  key: 'EmailSendingQueueManage_SmartPlanningState',
  default: {
    smartPlanningDate: null,
    smartPlanningDateLoaded: false,
    smartPlanningChanged: false,
    smartPlanningError: undefined
  }
})
